var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiExclamationTriangleSolid24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    part: "icon",
    id: "mi-exclamation-triangle-solid",
    shapeRendering: "geometricPrecision",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.289 2a1 1 0 0 0-.867.501l-9.2 15.98a1 1 0 0 0 .034 1.054l.68 1.02a1 1 0 0 0 .831.445h18.465a1 1 0 0 0 .832-.445l.68-1.02a1 1 0 0 0 .034-1.053L13.578 2.5A1 1 0 0 0 12.71 2h-1.422zm.21 12V8h1v6h-1zm-.25 3v-1.5h1.5V17h-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiExclamationTriangleSolid24Px);
export default __webpack_public_path__ + "static/media/mi-exclamation-triangle-solid-24px.fdd908f5af2939300a899bad327b98bd.svg";
export { ForwardRef as ReactComponent };